//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (https://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from "axios";

export class MenuClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : process.env.VUE_APP_BASE_API + "";
        // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://testgis123.khanhhoa.gov.vn/Gis/";
    }

    getMenuString(key: string, cancelToken?: CancelToken | undefined) {
        let url_ = this.baseUrl + `E_Menu_getByKey?key=${key}`;
        url_ = url_.replace(/[?&]$/, "");
        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "application/json",
            },
            cancelToken,
        };

        return this.instance
            .request(options_)
            .catch((_error: any) => {
                if (isAxiosError(_error) && _error.response) {
                    return _error.response;
                } else {
                    throw _error;
                }
            })
            .then((_response: AxiosResponse) => {
                return this.processGetMenuString(_response);
            });
    }

    protected processGetMenuString(response: AxiosResponse): Promise<MenuStringModelResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }

        if (status === 200) {
            const _responseText = response.data.Data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = MenuStringModelResponse.fromJS(resultData200);
            return Promise.resolve<MenuStringModelResponse>(result200);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MenuStringModelResponse>(null as any);
    }
}



export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): any {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

export class IMenuStringModelResponse {
    StatusCode?: number;
    description?: string;
    resultType?: string;
    status?: string;
    throwException?: boolean;
    resultObject?: MenuStringModel;
}

export class MenuStringModelResponse implements IMenuStringModelResponse {
    StatusCode?: number;
    description?: string;
    resultType?: string;
    status?: string;
    throwException?: boolean;
    resultObject?: MenuStringModel;

    constructor(data?: IMenuStringModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.StatusCode = _data["StatusCode"];
            this.description = _data["description"];
            this.resultType = _data["resultType"];
            this.status = _data["status"];
            this.throwException = _data["throwException"];
            this.resultObject = _data["resultObject"];
        }
    }

    static fromJS(data: any): MenuStringModelResponse {
        data = typeof data === "object" ? data : {};
        let result = new MenuStringModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === "object" ? data : {};
        data["StatusCode"] = this.StatusCode;
        data["description"] = this.description;
        data["resultType"] = this.resultType;
        data["status"] = this.status;
        data["throwException"] = this.throwException;
        data["resultObject"] = this.resultObject;
        return data;
    }
}

export interface IMenuStringModel {
    Key?: number;
    HTML?: string;
    CSS?: string;
}

export class MenuStringModel implements IMenuStringModel {
    Key?: number;
    HTML?: string;
    CSS?: string;
}
